const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const BUILDOUT_REQUEST_FORM_API_PATH = '/api/buildout-request-form/';

/**
 * True when a BRF API call was denied for authz (session-match or role gate).
 * Reloading the current web BRF page then hits abort(403) for the branded page.
 *
 * @param {string} url
 * @param {{ response?: { status?: number } }} error
 * @returns {boolean}
 */
export const shouldReloadForBuildoutRequestFormAccessDenied = (url, error) => {
  if (typeof url !== 'string' || !url.includes(BUILDOUT_REQUEST_FORM_API_PATH)) {
    return false;
  }

  const status = error?.response?.status;

  return status === HTTP_UNAUTHORIZED || status === HTTP_FORBIDDEN;
};

/**
 * Reload the current page so Laravel can render errors.403 on the web BRF route.
 *
 * @param {string} url
 * @param {{ response?: { status?: number } }} error
 * @returns {boolean} true when a reload was started
 */
export const reloadForBuildoutRequestFormAccessDenied = (url, error) => {
  if (!shouldReloadForBuildoutRequestFormAccessDenied(url, error)) {
    return false;
  }

  window.location.reload();

  return true;
};
